/**
 * Create by Alex
 * Description:
 *
 * ------ maintenance history ------
 * 2025/5/9 added to support impacted email rules
 */

import { businessConstants } from '../constants/business.constants';

export class ImpactedEmailRuleConfig {
    name: string;
    type: string;
    setting: string;

    /**
     * Parse the impacted email rules from response
     * @param serverResponse
     * @returns A array of impacted email rules
     */
    static parse(serverResponse): Array<ImpactedEmailRuleConfig> {
        const serverRes = serverResponse['emailRulesList'];
        if (!serverRes) {
            return null;
        }
        const impactedEmailRuleConfig: Array<ImpactedEmailRuleConfig> = new Array<ImpactedEmailRuleConfig>();

        if (serverRes && serverRes.length > 0) {
            serverRes.forEach(item => {
                impactedEmailRuleConfig.push(
                    {
                        name: item.name,
                        type: businessConstants.impactedConfigType.emailRule,
                        setting: item.field
                    }
                );
            });
        }
        return impactedEmailRuleConfig;
    }
}
